<template>
  <div
    class="tw-flex tw-items-center tw-justify-between"
    :class="
      tablePagination
        ? 'tw-font-bold tw-border-t tw-border-theme-3 tw-h-10 tw-bg-theme-3'
        : 'tw-py-4 mod-input--text-size'
    "
  >
    <div class="tw-flex tw-w-full tw-space-x-2 mod-input--height">
      <div class="tw-w-auto">
        <div
          class="tw-flex tw-h-full tw-items-center tw-px-2 xs:tw-px-4"
          :class="
            tablePagination
              ? 'tw-space-x-0.5'
              : 'game-input-background-color tw-space-x-1'
          "
        >
          <span>
            {{ humanNumberFormat(start) }}
          </span>
          <span>-</span>
          <span>
            {{ humanNumberFormat(end) }}
          </span>
          <span class="tw-whitespace-nowrap"
            >{{ $t('of') }} {{ humanNumberFormat(pagination.total) }}</span
          >
        </div>
      </div>
    </div>

    <nav
      v-if="totalPages > 1"
      class="tw-relative tw-inline-flex"
      :class="tablePagination ? 'tw-mr-2' : 'tw-space-x-2'"
    >
      <base-button
        :input-btn="tablePagination ? false : true"
        :basic-btn="tablePagination ? true : false"
        :class="{ 'tw-px-2 hover:game-link-color': tablePagination }"
        icon="angle-left"
        icon-size="lg"
        :disabled="isfirstPage"
        @click="prevPage"
      />

      <base-button
        :input-btn="tablePagination ? false : true"
        :basic-btn="tablePagination ? true : false"
        :class="{ 'tw-px-2 hover:game-link-color': tablePagination }"
        icon="angle-right"
        icon-size="lg"
        :disabled="islastPage"
        @click="nextPage"
      />
    </nav>
  </div>
</template>

<script>
import { humanNumberFormat } from '@helpers/utils.js'
import { usePagination } from '@composables'
import { computed } from 'vue'
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    tablePagination: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update', 'page'],
  setup(props, { emit }) {
    const { setPagination, totalPages, pagination, next, prev } = usePagination(
      props.id
    )

    const start = computed(() => {
      if (pagination.value.page === 0) {
        return 0
      }
      if (pagination.value.page === 1) {
        return 1
      } else {
        return (pagination.value.page - 1) * pagination.value.limit + 1
      }
    })

    const end = computed(() => {
      if (pagination.value.total <= pagination.value.limit) {
        return pagination.value.total
      }
      const end = pagination.value.page * pagination.value.limit
      if (end >= pagination.value.total) {
        return pagination.value.total
      } else {
        return end
      }
    })

    const islastPage = computed(
      () => pagination.value.page === totalPages.value
    )

    const isfirstPage = computed(() => pagination.value.page === 1)

    function nextPage() {
      if (!islastPage.value) {
        next()
        emit('update', 'next')
      }
    }

    function prevPage() {
      if (!isfirstPage.value) {
        prev()
        emit('update', 'prev')
      }
    }

    function updateLimit(limit) {
      setPagination({ limit })
      emit('update', 'limit')
    }

    function goToPage(page) {
      setPagination({ page })
      emit('update', 'page')
    }

    return {
      humanNumberFormat,
      updateLimit,
      isfirstPage,
      pagination,
      islastPage,
      totalPages,
      nextPage,
      goToPage,
      prevPage,
      start,
      end,
    }
  },
}
</script>
